import { Routes } from '@angular/router';
import { OpenBankingGuard } from '@iupics-util/guards/open-banking.guard';
import { PortalAccessGuard } from '@iupics-util/guards/portal-access.guard';
import { ResourceAccessGuard } from '@iupics-util/guards/resource-access.guard';

const routes: Routes = [
  {
    path: 'dashboard',
    loadComponent: () => import('@web-desktop/components/workspace/components/desktop-ui/desktop-ui.component'),
    canActivate: [PortalAccessGuard],
  },
  {
    path: 'workspace',
    canActivate: [PortalAccessGuard],
    children: [
      { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
      {
        path: 'window',
        canActivateChild: [ResourceAccessGuard],
        children: [
          { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
          {
            path: ':windowId',
            loadComponent: () => import('@web-desktop/components/workspace/components/desktop-ui/desktop-ui.component'),
          },
          {
            path: ':windowId/:recordId',
            loadComponent: () => import('@web-desktop/components/workspace/components/desktop-ui/desktop-ui.component'),
          },
        ],
      },
      {
        path: 'process',
        canActivateChild: [ResourceAccessGuard],
        children: [
          { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
          {
            path: ':processId',
            loadComponent: () => import('@web-desktop/components/workspace/components/desktop-ui/desktop-ui.component'),
          },
        ],
      },
      {
        path: 'form',
        canActivateChild: [ResourceAccessGuard],
        children: [
          { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
          {
            path: ':formId',
            loadComponent: () => import('@web-desktop/components/workspace/components/desktop-ui/desktop-ui.component'),
          },
        ],
      },
      {
        path: 'report',
        canActivateChild: [ResourceAccessGuard],
        children: [
          { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
          {
            path: ':reportId',
            loadComponent: () => import('@web-desktop/components/workspace/components/desktop-ui/desktop-ui.component'),
          },
        ],
      },
      {
        path: 'openBanking',
        canActivateChild: [OpenBankingGuard],
        children: [
          {
            path: '',
            loadComponent: () => import('@web-desktop/components/workspace/components/desktop-ui/desktop-ui.component'),
          },
        ],
      },
    ],
  },
  //! Beta features route
  {
    path: 'beta',
    children: [
      {
        path: 'studio',
        loadChildren: () => import('@studio/studio.routes').then((m) => [m.default]),
      },
      { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
    ],
  },
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'page-not-found',
    loadComponent: () => import('@iupics-util/components/status-page-layout/status-page-layout.component'),
  },
  { path: '**', redirectTo: 'page-not-found' },
];

export default routes;
